import React from 'react';
import { Link } from "react-router-dom";
import { BsFacebook, BsInstagram, BsTwitter } from "react-icons/bs";

// Redes sociales: completar con las URLs reales para activar el enlace.
const SOCIAL = {
    facebook: "",
    instagram: "",
    twitter: "",
};

function Social({ href, label, children }) {
    const base = "transition-colors duration-200 text-xl";
    if (!href) {
        return (
            <span aria-label={`${label} (próximamente)`} title="Próximamente" className={`${base} text-gray-600 cursor-default`}>
                {children}
            </span>
        );
    }
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={`${base} text-gray-400 hover:text-brand`}>
            {children}
        </a>
    );
}

export default function FooterPage() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-[#0a0a0f] border-t border-white/10">
            <div className="max-w-7xl mx-auto px-6 py-10">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-8">

                    <div className="flex flex-col items-center sm:items-start gap-3">
                        <img src="/identity/MONOLOGO.png" alt="Monoticket" className="h-10 object-contain" />
                        <p className="text-gray-500 text-xs text-center sm:text-left">
                            &copy; {year} Monoticket. Todos los derechos reservados.
                        </p>
                    </div>

                    <div className="flex flex-col items-center sm:items-end gap-4">
                        <div className="flex gap-5">
                            <Social href={SOCIAL.facebook} label="Facebook"><BsFacebook /></Social>
                            <Social href={SOCIAL.instagram} label="Instagram"><BsInstagram /></Social>
                            <Social href={SOCIAL.twitter} label="Twitter"><BsTwitter /></Social>
                        </div>
                        <div className="flex gap-5 text-xs text-gray-500">
                            <Link to="/privacidad" className="hover:text-white transition-colors duration-200">Política de Privacidad</Link>
                            <Link to="/terminos" className="hover:text-white transition-colors duration-200">Términos y Condiciones</Link>
                        </div>
                    </div>

                </div>
            </div>
        </footer>
    );
}
